type Fbq = {
  (event: 'init', pixelId: string): void;
  (event: 'track', name: string, params?: Record<string, unknown>): void;
  callMethod?: (...args: Array<unknown>) => void;
  queue?: Array<Array<unknown>>;
  push?: (...args: Array<unknown>) => void;
  loaded?: boolean;
  version?: string;
};

declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}

export const META_PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID ?? '';

export type MetaPixelStandardEvent = 'PageView' | 'CompleteRegistration';

export function metaPixelTrack(
  event: MetaPixelStandardEvent,
  params?: Record<string, unknown>
): void {
  if (typeof window === 'undefined') {
    return;
  }
  const fbq = window.fbq;
  if (typeof fbq !== 'function') {
    return;
  }

  try {
    fbq('track', event, params);
  } catch {
    // Never let tracking break user flows
  }
}

export function metaPixelTrackCompleteRegistrationOnce(userId: string): void {
  if (typeof window === 'undefined') {
    return;
  }
  if (!userId) {
    return;
  }

  const storageKey = `meta_pixel.complete_registration.${userId}`;
  try {
    if (sessionStorage.getItem(storageKey) === '1') {
      return;
    }
    sessionStorage.setItem(storageKey, '1');
  } catch {
    // If storage is unavailable, just fall back to best-effort tracking.
  }

  metaPixelTrack('CompleteRegistration');
}
